<template>
    <form @submit.prevent="submitHandler" v-if="onload">
      <div class="row">
        <div class="col-md-4 p-0">
          <div class="form-group user-type-select">
            <el-select v-if="showUserInfoField()" v-model="user.typeId" placeholder="Тип аккаунта" class="w-100" disabled>
              <el-option
                v-for="item in getuserTypesLabel()"
                :key="item.id"
                :label="item.profileLabel"
                :value="item.id">
              </el-option>
            </el-select>
            <PuSkeleton class="skeleton-input" v-else/>
          </div>
        </div>
        <div class="col-md-4 p-0">
          <div class="form-group user-type-select mt-3 ml-2">
            <ToggleSwitch class="flex align-center ml-3" v-model="user.autoConfirmOrders" @input="handleToggle">Автоматично оформлювати заявлені поліси</ToggleSwitch>
          </div>
        </div>
      </div>

        <personal-company-form v-if="userType.type_id === 1" ref="personalCompanyForm"></personal-company-form>
        <personal-form v-else ref="personalForm"></personal-form>
        <address-company-form v-if="userType.type_id === 1"></address-company-form>
        <address-form v-else></address-form>
        <personal-recipient-form v-if="!isPartner()" ref="personalRecipientForm"></personal-recipient-form>
        <personal-document-form v-if="!isPartner()" ref="personalDocumentForm"></personal-document-form>
<!--        <bank-details v-if="userType.type_id === 1"></bank-details>-->
        <div v-if="! isLandingUserType()" class="user-section mb-0">
            <div class="row">
                <div class="col-12 user-section-header">
                    <h4>Пароль:</h4>
                    <hr/>
                </div>
                <div class="col-lg-4">
                    <div class="form-group mb-0">
                        <div class="field-label">Змінити пароль</div>
                        <input v-model.trim="$v.password.$model"  type="password" name="password" placeholder="Новий пароль"
                               class="form-control ">

                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group mb-0">
                        <div class="field-label">Повторіть пароль</div>
                        <input  v-model.trim="$v.repeatPassword.$model" type="password" name="password_confirmation"
                               placeholder="Повторіть новий пароль" class="form-control" autocomplete="new-password">
                        <small class="error" v-if="!$v.repeatPassword.sameAsPassword">Пароль не збігається</small>
                    </div>
                </div>
            </div>
        </div>
        <hr/>

        <div v-if="!isPartner && userType && userType.type_id == 1" class="user-section">
            <div class="row">
                <div class="col-12 user-section-header">
                    <h3>Дані компанії</h3>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <input v-if="showUserInfoField()" type="text" v-model="user.companyInfo.name" value=""
                               placeholder="Назва компанії" class="form-control">
                        <PuSkeleton class="skeleton-input" v-else/>

                        <div class="invalid-feedback"></div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <input v-if="showUserInfoField()"
                               v-model="user.companyInfo.erdpyCode"
                               type="text" v-mask="'########'"
                               name="edrpu" placeholder="ЄДРПОУ" class="form-control ">
                        <PuSkeleton class="skeleton-input" v-else/>

                        <div class="invalid-feedback"></div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <multiselect
                            v-if="showUserInfoField()"
                            :class="['form-control', 'choice_city']"
                            v-model="user.companyInfo.city"
                            :options="citiesList"
                            placeholder="Місто реєстрації"
                            @search-change="searchCities"
                            :internal-search="false"
                            :max-height="165"
                            :options-limit="300"
                            :allow-empty="false"
                            label="name_full_name_ua">
                        </multiselect>
                        <PuSkeleton class="skeleton-input" v-else/>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <input v-if="showUserInfoField()" type="text" name="location"
                               v-model="user.companyInfo.address"
                               value=""
                               placeholder="Юр. адреса"
                               class="form-control ">
                        <PuSkeleton class="skeleton-input" v-else/>

                        <div class="invalid-feedback"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12 alert alert-info" v-if="formStatus == 'success'">
            Ваші дані успішно збережені!
        </div>
        <div class="col-lg-12 alert alert-danger" v-if="formStatus == 'error'">
            При відправці сталася помилка, перевірте ваші дані і повторіть відправку!
        </div>

    <!--     <div class="user-section d-lg-flex text-center justify-content-start mb-4 mb-lg-0"></div>  -->

        <div class="user-section mb-4 mb-lg-0">
            <div class="row">
                <div class="col-lg-4">
                    <button type="submit" class="btn btn-primary w-100">Зберегти зміни</button>
                </div>
                <div class="col-lg-4 mobile-mt">
                    <a href="#" class="btn btn-light w-100">Повернутися назад</a>
                </div>
            </div>
        </div>

    </form>
    <div v-else class="section-preloader">
        <img src="https://i.pinimg.com/originals/ae/51/e1/ae51e1395e87cc72c6021df5445cc5f8.gif">
    </div>


</template>

<script>
import PictureInput from 'vue-picture-input'
import Multiselect from 'vue-multiselect';
import {userMixin} from '@/mixin'
import profileForm from "@/components/app/profile/profileInfoForms/mixin/profileForm";
import {minLength, sameAs} from 'vuelidate/lib/validators';
import {mapActions} from "vuex";
import PersonalForm from "@/components/app/profile/profileInfoForms/PersonalForm.vue";
import PersonalCompanyForm from "@/components/app/profile/profileInfoForms/PersonalCompanyForm.vue";
import PersonalRecipientForm from "@/components/app/profile/profileInfoForms/PersonalRecipientForm.vue";
import PersonalDocumentForm from "@/components/app/profile/profileInfoForms/PersonalDocumentForm.vue";
import AddressForm from "@/components/app/profile/profileInfoForms/AddressForm.vue";
import AddressCompanyForm from "@/components/app/profile/profileInfoForms/AddressCompanyForm.vue";
import BankDetails from "@/components/app/profile/profileInfoForms/BankDetails.vue";
import { ToggleSwitch } from '@/shared/ui/form';

export default {
    name: 'profileInfo',
    mixins: [userMixin, profileForm],
    components: {
        BankDetails,
        AddressCompanyForm, AddressForm, PersonalCompanyForm, PersonalForm, PersonalRecipientForm, PersonalDocumentForm, Multiselect, PictureInput, ToggleSwitch},
    data: () => ({
        skeletonOff: false,
        password: '',
        repeatPassword: '',
        file: '',
        formStatus: '',
        citiesList: [],
        onload: true,
        documents: {
            firstPassportPage: '',
        }
    }),
    validations: {
        password: {
            minLength: minLength(6)
        },
        repeatPassword: {
            sameAsPassword: sameAs('password')
        },
    },

    methods: {
        ...mapActions([
            'getActivityTypes','getPeriodActsGenerate'
        ]),
        getuserTypesLabel() {
            return this.userTypes.filter(item => item.id !== 2).map(item => {
                const profileLabel = item.id === 1 ? 'Профіль юридичної особи' : 'Профіль фізичної особи';
                return {
                    id: item.id,
                    name: item.name,
                    profileLabel: profileLabel,
                };//matchingItem ? matchingItem : docId
            });
        },
        clearDocumentImg(document) {
            this.user.documents[document] = null;
            this.documents[document] = '';
        },
        showUserInfoField() {
            return this.skeletonOff;
        },
        fetchCities(query) {
            axios.get('/api/directories/cities/find?city=' + query).then(({data}) => {
                this.citiesList = data.data;
            }).catch(err => (console.log(err)));
        },
        searchCities(query) {
            if (query.length > 1) {
                this.fetchCities(query);
            }
        },
        handleToggle(checked) {
          this.user.autoConfirmOrders = checked;
        },
        onSuccess(res, file) {
            // console.log(file);
        },
        submitHandler() {
            // if (this.$v.$invalid) {
            //     this.$v.$touch()
            //
            //     return
            // }
            // Получаем ссылки на дочерние компоненты personal-document-form
            const personalDocumentForm = this.$refs.personalDocumentForm;

            //console.log(this.isLegalType())
            if (this.isLegalType() && this.$refs.personalCompanyForm.$v.$invalid) {
                this.$refs.personalCompanyForm.$v.$touch()

                return
            } else if(!this.isLegalType() && this.$refs.personalForm.$v.$invalid) {
                this.$refs.personalForm.$v.$touch()

                return
            } else if (!this.isPartner() && this.$refs.personalRecipientForm.$v.$invalid) {
                this.$refs.personalRecipientForm.$v.$touch()

                return
            }
            else if (!this.isPartner() && this.$refs.personalDocumentForm.$v.$invalid) {
                this.$refs.personalDocumentForm.$v.$touch()

                return
            }

            let data = new FormData();

            data.append("documents[firstPassportPage]", this.documents.firstPassportPage);
            data.append("typeId", this.user.typeId);
            data.append("email", this.user.email);
            data.append("name", this.user.name);
            data.append("password", this.password);
            data.append("surname", this.user.surname || '');
            data.append("patronymic", this.user.patronymic || '');
            data.append("uin", this.user.uin || '');
            data.append("cityId", this.user.city?.id || '');
            data.append("street", this.user.street || '');
            data.append("house", this.user.house || '');
            data.append("apartment", this.user.apartment || '');
            data.append("birthdayAt", this.user.birthdayAt || '');
            data.append("phone", this.user.phone || '');
            data.append("activityTypeId", this.user.activityTypeId || '');
            data.append("periodActsGenerateId", this.user.periodActsGenerateId || '');

            data.append("recipientTypeId", this.user.recipientTypeId ?? 0);
            data.append("recipientName", this.user.recipientName || '');
            data.append("recipientCode", this.user.recipientCode || '');
            data.append("recipientAccount", this.user.recipientAccount || '');
            data.append("recipientBankName", this.user.recipientBankName || '');
            data.append("recipientBankCard", this.user.recipientBankCard || '');
            //data.append("withdrawalPeriod", this.user.withdrawalPeriod || '');

            data.append("contractNumber", this.user.contractNumber || '');
            data.append("nbuId", this.user.nbuId || '');
            data.append("nbuNumber", this.user.nbuNumber || '');

            data.append("autoConfirmOrders", this.user.autoConfirmOrders ? 1 : 0);


            // if (personalDocumentForm) {
            //     const uploadedFiles = personalDocumentForm.getFilesForUpload();
            //
            //     // Обработка файла контракта
            //     if (uploadedFiles.contract instanceof File) {
            //         data.append("contractPath", uploadedFiles.contract);
            //     } else if (uploadedFiles.contract === '') {
            //         data.append("contractPath", "");
            //     }
            //
            //     // Обработка файла паспорта
            //     if (uploadedFiles.passport instanceof File) {
            //         data.append("passportPath", uploadedFiles.passport);
            //     } else if (uploadedFiles.passport === '') {
            //         data.append("passportPath", "");
            //     }
            // }

            data.append("contractPath", this.user.contractPath || '');
            data.append("passportPath", this.user.passportPath || '');
            data.append("ipnPath", this.user.ipnPath || '');
            data.append("edrExtractPath", this.user.edrExtractPath || '');
            data.append("accountCertificatePath", this.user.accountCertificatePath || '');
            data.append("placeResidencePath", this.user.placeResidencePath || '');




            data.append("companyInfo[name]", this.user.companyInfo.name || '');
            data.append("companyInfo[cityId]", this.user.companyInfo.city?.id || '');
            data.append("companyInfo[street]", this.user.companyInfo.street || '');
            data.append("companyInfo[house]", this.user.companyInfo.house || '');
            data.append("companyInfo[office]", this.user.companyInfo.office || '');
            data.append("companyInfo[erdpyCode]", this.user.companyInfo.erdpyCode || '');
            data.append("companyInfo[bankName]", this.user.companyInfo.bankName || '');
            data.append("companyInfo[bankMfo]", this.user.companyInfo.bankMfo || '');
            data.append("companyInfo[bankIban]", this.user.companyInfo.bankIban || '');

            this.$store.dispatch('updateProfileInfo', data).then(() => {
                    this.$store.dispatch('getProfileInfo')
                    this.$store.dispatch('GET_USERINFO')
                    this.onload = true
                    this.formStatus = 'success'
                }
            )
            .catch(err => {
                console.log(err)
                this.onload = true
                this.formStatus = 'error'
            })
        }
    },
    mounted() {
        this.getActivityTypes();
        this.getPeriodActsGenerate();

        this.$store.dispatch('getProfileInfo')
            .then((result) => {
                this.user = result.data?.data;
                this.skeletonOff = true;
            });
    },
    computed: {
        userType: function () {
            return this.$store.getters.USER_INFO
        },
        user: {
            get() {
                return this.$store.getters.PROFILE_INFO ? this.$store.getters.PROFILE_INFO : null;
            },
            set(value) {
                this.$store.commit('SET_PROFILE_INFO', value)
            }
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
